import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import NotListedLocationIcon from "@material-ui/icons/NotListedLocation";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  dialog: {
    padding: theme.spacing(2),
    position: "absolute",
    top: theme.spacing(5),
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    textAlign: "center",
  },
  dialogAction: {
    justifyContent: "center",
  },
  titleIcon: {
    backgroundColor: theme.palette.confirmDialog.light,
    color: theme.palette.confirmDialog.main,
    "& :hover": {
      backgroundColor: theme.palette.confirmDialog.light,
      cursor: "default",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "8rem",
    },
  },
  confirmButton: {
    backgroundColor: theme.palette.confirmDialog.light,
    "& .MuiButton-label": {
      color: theme.palette.confirmDialog.main,
    },
  },
}));

const ConfirmDialog = (props) => {
  const { t } = useTranslation();
  const { confirmDialog, setConfirmDialog } = props;
  const classes = useStyles();

  return (
    <Dialog open={confirmDialog.isOpen} classes={{ paper: classes.dialog }}>
      <DialogTitle>
        <IconButton disableRipple className={classes.titleIcon}>
          <NotListedLocationIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="h6">
          {t(confirmDialog.title.toUpperCase())}
        </Typography>
        <Typography variant="subtitle2">
          {t(confirmDialog.subTitle.toUpperCase())}
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialogAction}>
        <Button
          onClick={() => setConfirmDialog({ ...confirmDialog, isOpen: false })}
        >
          {t("No")}
        </Button>
        <Button
          className={classes.confirmButton}
          onClick={confirmDialog.onConfirm}
        >
          {t("Yes")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  confirmDialog: PropTypes.object,
  setConfirmDialog: PropTypes.func,
};

export default ConfirmDialog;
